import { Outlet } from "@remix-run/react";

import { ExitSurveyHost } from "~/components/exit-survey";
import { Footer, Header } from "~/components/shared/Header";

export default function StoreLayout() {
    return (
        <>
            <Header to="/" />
            <main className="flex flex-col grow min-h-screen">
                <Outlet />
            </main>
            <Footer to="/" />
            <ExitSurveyHost layout="store" />
        </>
    );
}
